import { Component, Mixins, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import ProjectUser from '@/views/Authorization/models/projectUser'
import User from '@/views/User/models/user'

import Role from '@/views/Authorization/models/role'

import UserAvatar from '@/_components/avatar/user/user.vue'
import UserCheckbox from '@/views/Authorization/components/userChkbox/userChkbox.vue'

import { initDialog } from '@/utils/dialog'
import ProjectUserInvitationDialog from '../../dialogs/invitation.vue'
@Component({
    components: { UserAvatar, UserCheckbox },
})
export default class UserRow extends Mixins<MixinInterface>() {
    @Prop({ required: true }) user!: ProjectUser | User | string
    @Prop({ default: true }) disabled!: boolean
    @Prop() searchTerm!: string | null
    @Prop({ type: Boolean }) canManageUsers!: boolean
    @Prop({ type: Boolean }) canManageRolesAndAssignments!: boolean
    @Prop() contractor!: { id: string; name: string }

    temporaryDisabled = false

    get projectContractorPath() {
        if (this.user instanceof ProjectUser && this.user.displayContractor.namePath.length > 1) {
            return this.user.displayContractor.namePath.join(' → ')
        }
        return ''
    }

    get contractorAssignments() {
        if (!(this.user instanceof ProjectUser)) return ''

        return Array.from(
            new Set(this.user.contractorAssignments.filter(Boolean).map((c) => c.contractor.name))
        ).join(', ')
    }

    get roles(): Array<Role> {
        let roles: any[] = []

        if (this.canManageRolesAndAssignments) {
            roles = this.$store.getters.roles.filter((role) => role.isNormal)
        } else if (this.canManageUsers) {
            roles = this.currentProjectUser._roles?.filter((role) => role.isNormal) || []
            if (this.contractor && Array.isArray(this.currentProjectUser?.contractorAssignments)) {
                let contractorAssignment = this.currentProjectUser.contractorAssignments.find(
                    (assignment) => assignment.contractor._id === this.contractor.id
                )
                contractorAssignment?.roleAssignments.forEach((ra) => {
                    roles.push(ra.role)
                })
            }
        }

        return roles
    }

    get isEmail() {
        return typeof this.user == 'string' ? true : false
    }

    get isProjectUser() {
        return typeof this.user == 'object' && 'isProjectUser' in this.user ? true : false
    }

    async showEditUserDialog() {
        if (this.isProjectUser && this.user instanceof ProjectUser) {
            const closeAction = await this.user.editProjectUser(this.user, this.contractor)
            this.$emit('close', closeAction)
            if (closeAction === 'user:deleted') {
                this.$emit(closeAction)
            }
        }
    }

    async sendInvitation() {
        if (typeof this.user == 'object' && 'isProjectUser' in this.user) {
            let res = await initDialog(ProjectUserInvitationDialog, { projectUser: this.user })
            if (res) {
                this.$store.commit('setSuccessSnackBar', {
                    subtitle: this.$t(
                        `authorization_fe['projectUserInvitation.dialog.snackbar.success']`
                    ),
                    timeout: 5000,
                })
            }
        }
    }
}
